export const CAKTO_EMAIL_DOMAIN = '@cakto.com.br';

export function isCaktoUser(user) {
  return Boolean(user?.email?.endsWith(CAKTO_EMAIL_DOMAIN));
}
